import { testItemsApi, testsApi } from '@edulastic/api'
import { notification } from '@edulastic/common'
import {
  all,
  call,
  put,
  select,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects'
import {
  fetchTTSTextAction,
  fetchTestTTSTextAction,
  setTTSTextStateAction,
  setTTSUpdateDataAction,
} from '../actions/ttsText'
import {
  FETCH_TEST_TTS_TEXT,
  FETCH_TTS_TEXT,
  UPDATE_TTS_TEXT,
  UPDATE_TEST_TTS_TEXT,
} from '../constants/actions'
import {
  getTestSelector,
  getTestsUpdatedSelector,
  updateTestAction,
} from '../../TestPage/ducks'

function* fetchTTSTextSaga({ payload }) {
  const failedMessage =
    'Apologies for the inconvenience. We encountered an issue while generating speakable text for this question. Please try again'

  try {
    yield put(setTTSTextStateAction({ apiStatus: 'INITIATED', result: [] }))
    const { result } = yield call(testItemsApi.getTTSText, payload)
    yield put(setTTSTextStateAction({ apiStatus: 'SUCCESS', result }))
  } catch (err) {
    yield put(setTTSTextStateAction({ apiStatus: 'FAILED', result: [] }))
    const errorMessage = failedMessage
    notification({ msg: errorMessage })
  }
}

function* fetchTestTTSTextSaga({ payload }) {
  const failedMessage =
    'Apologies for the inconvenience. We e ncountered an issue while generating speakable text for this test. Please try again'

  try {
    const testsUpdated = yield select(getTestsUpdatedSelector)
    if (testsUpdated) {
      const data = yield select(getTestSelector)

      yield put(
        updateTestAction(
          data._id,
          { ...data, nextAction: fetchTestTTSTextAction(payload) },
          false
        )
      )
    } else {
      yield put(setTTSTextStateAction({ apiStatus: 'INITIATED', result: [] }))
      const { result } = yield call(testsApi.getTestTTSInstruction, payload)
      yield put(setTTSTextStateAction({ apiStatus: 'SUCCESS', result }))
    }
  } catch (err) {
    yield put(setTTSTextStateAction({ apiStatus: 'FAILED', result: [] }))
    const errorMessage = failedMessage
    notification({ msg: errorMessage })
  }
}

function* updateTTSTextSaga({ payload }) {
  const { itemId, questionId, language, updateTTSText = false } = payload
  const failedMessage =
    'Apologies for the inconvenience. We encountered an issue while regenerating tts for this question. Please try again'

  try {
    yield put(
      setTTSUpdateDataAction({
        TTSUpdateData: {
          apiStatus: 'INITIATED',
        },
      })
    )
    yield call(testItemsApi.updateTTSText, payload)
    yield put(
      setTTSUpdateDataAction({
        TTSUpdateData: {
          apiStatus: 'SUCCESS',
        },
      })
    )
    yield put(setTTSTextStateAction({ apiStatus: false, result: [] }))
    notification({
      type: 'success',
      msg: `TTS regeneration is in progress. Please check after few minutes`,
    })
    yield put(
      fetchTTSTextAction({ itemId, questionId, updateTTSText, language })
    )
  } catch (err) {
    yield put(
      setTTSUpdateDataAction({
        TTSUpdateData: {
          apiStatus: 'FAILED',
        },
      })
    )
    const errorMessage = failedMessage
    notification({ msg: errorMessage })
  }
}

function* updateTestTTSTextSaga({ payload }) {
  const { testId, language, updateTTSText = false, data } = payload
  const failedMessage =
    'Apologies for the inconvenience. We encountered an issue while regenerating tts for this question. Please try again'

  try {
    yield put(
      setTTSUpdateDataAction({
        TTSUpdateData: {
          apiStatus: 'INITIATED',
        },
      })
    )
    const {
      text = '',
      instructionAcknowledgementText: { text: acknowledgementText = '' } = {},
    } = data

    const reqBody = {
      text,
      ...(acknowledgementText && {
        instructionAcknowledgementText: {
          text: acknowledgementText,
        },
      }),
    }

    yield call(testsApi.updateTTSInstruction, {
      data: reqBody,
      testId,
      language,
    })
    yield put(
      setTTSUpdateDataAction({
        TTSUpdateData: {
          apiStatus: 'SUCCESS',
        },
      })
    )
    yield put(setTTSTextStateAction({ apiStatus: false, result: [] }))
    notification({
      type: 'success',
      msg: `TTS regeneration is in progress. Please check after few minutes`,
    })
    yield put(fetchTestTTSTextAction({ testId, updateTTSText, language }))
  } catch (err) {
    yield put(
      setTTSUpdateDataAction({
        TTSUpdateData: {
          apiStatus: 'FAILED',
        },
      })
    )
    const errorMessage = failedMessage
    notification({ msg: errorMessage })
  }
}

export default function* watcherSaga() {
  yield all([
    takeEvery(FETCH_TTS_TEXT, fetchTTSTextSaga),
    takeLatest(UPDATE_TTS_TEXT, updateTTSTextSaga),
    takeLatest(FETCH_TEST_TTS_TEXT, fetchTestTTSTextSaga),
    takeLatest(UPDATE_TEST_TTS_TEXT, updateTestTTSTextSaga),
  ])
}
